import { api } from "@/lib/api";

export const fetchBlobUrl = async (path) => {
  const r = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(r.data);
};

export const downloadFile = async (path, filename) => {
  const url = await fetchBlobUrl(path);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

export const KIND_LABELS = { kit: "Kit del mese", tip: "Consiglio operativo", promo: "Contenuto promozionale" };

const ROME_FMT = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Rome", year: "numeric", month: "2-digit" });
export const romeMonth = (d) => ROME_FMT.format(new Date(d)).slice(0, 7);

export const apiError = (err, fallback) => {
  const d = err?.response?.data?.detail;
  return typeof d === "string" ? d : d?.message || fallback;
};

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
